document.addEventListener('DOMContentLoaded', function () {
  // Кликаем по меню
  const menuLinks = document.querySelectorAll('.nav-link[data-feature]');
  const sections = document.querySelectorAll('.article-section');

  menuLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      // Активный класс
      menuLinks.forEach(l => l.classList.remove('active'));
      link.classList.add('active');

      // Получаем выбранный feature
      const selectedFeature = link.dataset.feature;

      // Фильтруем секции: показываем только те, что содержат выбранный тег
      sections.forEach(section => {
        const tags = section.dataset.featureTags.split(',').map(s => s.trim());
        if (tags.includes(selectedFeature)) {
          section.style.display = '';
        } else {
          section.style.display = 'none';
        }
      });

      // Открываем подменю, если подпункт
      const parentCollapse = link.closest('.collapse');
      if (parentCollapse) {
        const parentToggle = parentCollapse.previousElementSibling;
        if (parentToggle && parentToggle.classList.contains('dropdown-toggle')) {
          parentToggle.classList.add('active');
          parentToggle.setAttribute('aria-expanded', 'true');
          parentCollapse.classList.add('show');
        }
        // Закрываем остальные подменю
        document.querySelectorAll('.collapse').forEach(el => {
          if (el !== parentCollapse) {
            el.classList.remove('show');
            const pt = el.previousElementSibling;
            if (pt && pt.classList.contains('dropdown-toggle')) {
              pt.classList.remove('active');
              pt.setAttribute('aria-expanded', 'false');
            }
          }
        });
      } else {
        // Закрываем все подменю, если выбрали пункт верхнего уровня
        document.querySelectorAll('.collapse').forEach(el => {
          el.classList.remove('show');
          const pt = el.previousElementSibling;
          if (pt && pt.classList.contains('dropdown-toggle')) {
            pt.classList.remove('active');
            pt.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
  });

  // "Показать все" — если хотите, можно добавить пункт меню, чтобы показывал все секции:
  // document.getElementById('feature-show-all').addEventListener('click', function(e) {
  //   e.preventDefault();
  //   sections.forEach(section => section.style.display = '');
  //   menuLinks.forEach(l => l.classList.remove('active'));
  //   // и т.д.
  // });

  // При загрузке показать все (или нужный фильтр)
  // sections.forEach(section => section.style.display = '');
});
